import React, { useCallback, useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';

import useSearch from '../../hooks/useSearch';
import { useTabs } from '../../hooks/useTabs';
import { CATEGORIES, SUBCATEGORIES } from '../../common/categories';
import { fieldsReducer, initFieldsState, mapToSettings } from './licensingReducer';
import { httpPost } from '../../../utils';
import { USER_ENGAGEMENT_PAGE_KEYS } from '@silverfort-nodelibs/common/utils/consts';
import MobileMessagingServices from '../../components/MobileMessagingServices/MobileMessagingServices';
import NewCategory from '../../components/Category/NewCategory';
import { useSaveSettings } from '../../hooks/useSaveSettings';
import { UPDATE_LICENSE } from './licensingActions';
import { LICENSE_FIELDS } from '../../common/fields';
import License from '../../components/License/License';
import { useVisibleTabs } from '../../hooks/lockedFeatures/useVisibleTabs';
import { filterServiceBus } from '../../common/utils';

const { LICENSE_KEY } = LICENSE_FIELDS;

const { LICENSING } = CATEGORIES;
const { LICENSE, MOBILE_MESSAGING_SERVICES } = SUBCATEGORIES;

const LicensingNew = ({ saveFunc, systemMode }) => {
    const settings = useSelector((state) => state.settings.settings);
    const [fields, dispatch] = useReducer(fieldsReducer, { settings }, initFieldsState);
    const hasServiceBus = fields[MOBILE_MESSAGING_SERVICES.ID] !== undefined;
    const visibleFields = useSearch(useVisibleTabs(filterServiceBus(fields, hasServiceBus)));
    const [selectedTab, setSelectedTab] = useTabs(LICENSING, visibleFields);
    const [save] = useSaveSettings(saveFunc, settings, mapToSettings, fields, selectedTab, dispatch, {}, {}, true);
    const onCancel = useCallback(() => {
        if (settings.License) {
            dispatch({
                type: UPDATE_LICENSE,
                payload: {
                    licenseDetails: settings.License,
                    senderConnectionStrings: settings.RavenSendConnectionStrings,
                    receiverConnectionStrings: settings.RavenReceiveConnectionStrings,
                    systemMode
                }
            });
        }
    }, [settings, dispatch, systemMode]);

    let content = null;
    if (visibleFields[LICENSE.ID] && selectedTab === LICENSE.ID) {
        if (
            // since license details field is not synced with redux, we sync it on settings change
            settings.License?.licenseData &&
            visibleFields[LICENSE.ID].fields[LICENSE_KEY.ID] &&
            !visibleFields[LICENSE.ID].fields[LICENSE_KEY.ID].isDirty &&
            JSON.stringify(visibleFields[LICENSE.ID].fields[LICENSE_KEY.ID].licenseDetails) !==
                JSON.stringify(settings.License)
        ) {
            dispatch({
                type: UPDATE_LICENSE,
                payload: {
                    licenseDetails: settings.License,
                    senderConnectionStrings: settings.RavenSendConnectionStrings,
                    receiverConnectionStrings: settings.RavenReceiveConnectionStrings,
                    systemMode
                }
            });
        }

        content = (
            <License
                fields={visibleFields[LICENSE.ID].fields}
                save={save}
                dispatch={dispatch}
                licenseExtraData={settings.licenseExtraData}
                onCancel={onCancel}
            />
        );
    } else if (visibleFields[MOBILE_MESSAGING_SERVICES.ID] && selectedTab === MOBILE_MESSAGING_SERVICES.ID) {
        content = (
            <MobileMessagingServices fields={visibleFields[MOBILE_MESSAGING_SERVICES.ID].fields} dispatch={dispatch} />
        );
    }

    useEffect(() => {
        httpPost('/data/userEngagement', { pageId: USER_ENGAGEMENT_PAGE_KEYS.SETTINGS_LICENSING });
    }, []);

    return (
        <NewCategory
            category={LICENSING}
            fields={fields}
            visibleFields={visibleFields}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}>
            {content}
        </NewCategory>
    );
};

export default LicensingNew;
